module.exports = __webpack_public_path__ + "img/my.c1d190c3.svg";